import { RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.teamMembers,
    element: <Loadable component={() => import('./pages/TeamMembersPage')} />,
  },
];
